<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-support">
  <div class="consumer-support--layout">
    <app-consumer-sidebar class="consumer-support--sidebar"></app-consumer-sidebar>
    <div class="consumer-support--content">
      <app-page-header></app-page-header>
      <div class="support--container">
        <app-support></app-support>
      </div>
    </div>
  </div>
</div>




